import * as React from 'react';
import type { SVGProps } from 'react';
const Hamburger = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h32v32H0z" />
            <g stroke="#00BFFB" strokeLinecap="square" strokeWidth={2}>
                <path d="M5 24h22M5 16h22M5 8h22" />
            </g>
        </g>
    </svg>
);
export default Hamburger;
